RivalIQ.apps.Dashboard.module('curations.filters', function (filters, App, Backbone, Marionette, $, _) {

    'use strict';

    filters.setupExport = {
        action: function (curation) {
            if (curation.isExporting()) {
                RivalIQ.export.startExport(curation);
            }
        }
    };

    /*
     * If we loaded this page to kick off a scheduled export, do that!
     */
    filters.triggerScheduledReport = function (curation) {
        const scheduleId = curation.getProp('scheduleId');

        if (!_.isUndefined(scheduleId)) {
            if (!_.isNumber(scheduleId)) {
                return RivalIQ.export.failExport('ScheduleId is not a number');
            }

            // NOTE as extra security to prevent rescheduling, switch the prop
            // name
            curation.setProps({
                scheduleId: undefined,
                isSchedule: true
            }, {
                silent: true,
                navigate: false
            });

            return curation.buildScheduledReport({
                reportScheduleId: scheduleId
            }).save()
                .fail(function (xhr, status, msg) {
                    RivalIQ.export.failExport(msg);
                })
                .then(_.noop);
        }
    };

    filters.triggerExportTestHook = function (curation) {
        const triggerExportId = curation.getProp('triggerExport');

        if (!_.isUndefined(triggerExportId)) {
            const pieces = triggerExportId.split(':');
            const instanceId = pieces[0];
            const format = pieces[1];
            let model;

            if (instanceId === 'page') {
                model = curation;
                model.unset('triggerExportId', {
                    silent: true
                });
            } else {
                model = curation.getWidget(instanceId);
                delete model.curationProps.triggerExport;
            }

            RivalIQ.export.startExport(curation);
            return RivalIQ.export.download(format, model)
                .then(function () {
                    RivalIQ.export.completeExport(curation);
                });
        }

    };

    filters.completeExport = function (curation) {
        if (curation.isExporting()) {
            RivalIQ.export.completeExport(curation);
        }
    };
});
